import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireLib } from '../node_modules/svg-inline-react/lib/index.js';

var libExports = requireLib();
var InlineSVG = /*@__PURE__*/getDefaultExportFromCjs(libExports);

export { InlineSVG as default };
